// src/pages/dashboard/Premium/index.tsx
import React from 'react';
import PremiumActive from './PremiumActive';
import PremiumPreview from './PremiumPreview';

interface Props {
  isPremium: boolean;
  goToMyResearch?: () => void;
}

const Premium: React.FC<Props> = ({ isPremium, goToMyResearch }) => {
  return isPremium ? (
    <PremiumActive />
  ) : (
    <PremiumPreview onGoInvestigations={goToMyResearch} />
  );
};

export default Premium;
